import packageJson from '../../../package.json';
import { useAppSelector } from '../../hooks/redux';
import { RootState } from '../../store/store';
import { shortText } from '../../utils/formatting';

function GameId() {

  const gameState = useAppSelector((state: RootState) => state.game);

  // maybe makes sense to move to status bar
  return (
    <div className="game-id">
      <span>{shortText(gameState.gameId)}</span>
    </div>
  );
}

export default GameId;

